import React from 'react';

// List of functions to call when starting/ending a connection (event listener optimization)
export default React.createContext([]);
